import { provide, inject, InjectionKey, reactive } from '@vue/composition-api'
import { Conversation } from '@/rest/conversations-api'

interface CurrentConversationState {
  conversation: Conversation | null
}

const defaultState = () => reactive({ conversation: null })

const currentConversation = (
  currentConversationState: CurrentConversationState
) => {
  const getConversation = () => currentConversationState.conversation
  const setConversation = (replacement: Conversation) =>
    (currentConversationState.conversation = replacement)

  return {
    getConversation,
    setConversation
  }
}

export type CurrentConversation = ReturnType<typeof currentConversation>

const CurrentConversationKey: InjectionKey<CurrentConversation> = Symbol()

export const useCurrentConversation = () => inject(CurrentConversationKey)
export const provideCurrentConversation = () =>
  provide(CurrentConversationKey, currentConversation(defaultState()))
